import { GridCellParams } from "@mui/x-data-grid";
import { differenceInDays, parseISO } from "date-fns";
import { psyEvaluationsOptions } from "../../psy-evaluations/psyEvaluationsOptions";
import { UseRecordsOptions } from "../../../api/useRecords";

const passwordValidityColumn = {
	field: "password_validity",
	headerName: "Válido",
	width: 150,
	renderCell: (params: GridCellParams) => {
		const status = params.row?.status;
		if (status === "completed" || status === "completed_no_snapshot") return "-";
		const expirationDate = params.row?.password_expiration_date;
		if (!expirationDate) return null;
		const daysLeft = differenceInDays(parseISO(expirationDate), new Date());
		const isValid = daysLeft >= 0;
		if (!isValid) return "Não";
		return `Sim (${daysLeft} ${daysLeft === 1 ? "dia" : "dias"})`;
	},
};

export const instrumentsResponsesOptions = {
	...psyEvaluationsOptions,
	relatedRecords: {
		hideCreationButton: false,
	},
	extraOptions: {
		sort: "-date_created",
	},
	dataGridOptions: {
		...psyEvaluationsOptions.dataGridOptions,
		extraColumns: {
			...psyEvaluationsOptions.dataGridOptions?.extraColumns,
			end: [passwordValidityColumn],
		},
	},
} as UseRecordsOptions;

export const leadInstrumentsResponsesOptions = {
	...instrumentsResponsesOptions,
	relatedRecords: {
		hideCreationButton: true,
	},
	dataGridOptions: {
		...instrumentsResponsesOptions.dataGridOptions,
		navigateToDetail: () => ".",
	},
} as UseRecordsOptions;
